import { useTranslation } from "react-i18next";
import { Chat as ChatFeature } from "@/partner/features/chat";
import { Meta } from "@/shared/components";

export function ChatPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("chat.pageTitle")} pageType="Partner" />
      <ChatFeature />
    </>
  );
}
